"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _material = require("@mui/material");

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _Text = _interopRequireDefault(require("../Text"));

var _excluded = ["open", "handleClose", "title", "actionButtons", "isFullscreen", "children", "withCloseButton"];

var _templateObject, _templateObject2, _templateObject3;

var StyledDialog = (0, _styledComponents.default)(_material.Dialog)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n"])), function (_ref) {
  var fullScreen = _ref.fullScreen;
  return fullScreen && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    .MuiDialogTitle-root {\n      padding: 0;\n    };\n    .MuiDialogContent-root {\n      padding: 0;\n    };\n  "])));
});

var StyledDialogTitle = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  h2{\n    ", " {\n      font-size: 18px;\n    }\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down('sm');
});

var Modal = function Modal(_ref3) {
  var open = _ref3.open,
      handleClose = _ref3.handleClose,
      title = _ref3.title,
      actionButtons = _ref3.actionButtons,
      isFullscreen = _ref3.isFullscreen,
      children = _ref3.children,
      withCloseButton = _ref3.withCloseButton,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return /*#__PURE__*/_react.default.createElement(StyledDialog, Object.assign({
    open: open,
    onClose: handleClose,
    fullScreen: isFullscreen,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    maxWidth: "xl"
  }, rest), /*#__PURE__*/_react.default.createElement(StyledDialogTitle, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "h2"
  }, title), handleClose && withCloseButton ? /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": "close",
    onClick: handleClose,
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    color: "secondary"
  })) : null), /*#__PURE__*/_react.default.createElement(_material.DialogContent, null, children), actionButtons && /*#__PURE__*/_react.default.createElement(_material.DialogActions, null, actionButtons));
};

Modal.defaultProps = {
  actionButtons: [],
  handleClose: function handleClose() {
    return null;
  },
  withCloseButton: false,
  title: '',
  isFullscreen: false
};
var _default = Modal;
exports.default = _default;